import { createFileRoute } from '@tanstack/react-router'
import { paymentHistorySearchSchema } from '@/features/payments/filter-payment-history/model/paymentHistorySearch'
import { PaymentsPage } from '@/pages/profile/payments/ui/PaymentsPage'

export const Route = createFileRoute('/payments')({
  validateSearch: paymentHistorySearchSchema,
  component: PaymentsPage,
})
